import React from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import AccountSidebar from '../components/AccountSidebar/AccountSidebar'
import ProfileInfo from '../components/ProfileInfo/ProfileInfo'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'

function Profile() {
  
  return (
    <>
    <NavbarContainer/>
    {/* <PageHeader title={'Profile'} /> */}

    <Container>
      <Row>
        <Col md={3}>
        <AccountSidebar/>

        </Col>
        <Col md={9}>
        <ProfileInfo/>

        </Col>
      </Row>
    </Container>
    <Footer/>
    </>
  )
}

export default Profile